export const getCookie = (name: string) => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
  return match ? decodeURIComponent(match.split('=')[1]) : ''
}

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; Max-Age=0; path=/`
}
